import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { Box, Stack, Tooltip, Typography } from '@mui/material'
import { alpha } from '@mui/material/styles'

import {
  COLOR_OPS_NOTES,
  EXCEPTION_METRICS_FOOTNOTES,
  EXCEPTION_METRICS_INFO,
} from 'components/reports/Metrics/constants/ExceptionMetrics'

import { ExceptionMetricsCards } from './ExceptionMetricsCards'
import { ExceptionMetricsFilterCriteria } from './ExceptionMetricsFilterCriteria'
import { ExceptionMetricsFiltersForm } from './ExceptionMetricsFilters'

export const ExceptionMetrics = () => (
  <ExceptionMetricsFilterCriteria>
    <Box>
      <Stack
        direction={{ xs: 'column', lg: 'row' }}
        spacing={2}
        alignItems={{ xs: 'stretch', lg: 'flex-end' }}
        justifyContent='space-between'
        mb={3}>
        <Box>
          <Stack direction='row' spacing={1} alignItems='center'>
            <Typography variant='h5' fontWeight={700} sx={{ color: 'primary.main' }}>
              Exception Metrics
            </Typography>
            <Tooltip
              title={EXCEPTION_METRICS_INFO}
              slotProps={{ tooltip: { sx: { whiteSpace: 'pre-line', maxWidth: 420 } } }}>
              <InfoOutlinedIcon fontSize='small' sx={{ color: 'text.disabled' }} />
            </Tooltip>
          </Stack>
          <Typography variant='body2' color='text.secondary'>
            Monitor operational friction and exception rates across the network.
          </Typography>
        </Box>

        <ExceptionMetricsFiltersForm />
      </Stack>

      <ExceptionMetricsCards />

      <Box
        sx={{
          mt: 3,
          px: 2,
          py: 1.5,
          borderRadius: 2,
          bgcolor: alpha(COLOR_OPS_NOTES, 0.04),
          border: 1,
          borderColor: alpha(COLOR_OPS_NOTES, 0.2),
        }}>
        <Stack direction='row' spacing={1.25} alignItems='flex-start'>
          <InfoOutlinedIcon sx={{ fontSize: 18, color: COLOR_OPS_NOTES, mt: 0.25 }} />
          <Box>
            {EXCEPTION_METRICS_FOOTNOTES.map((line) => (
              <Typography
                key={line}
                variant='caption'
                color='text.secondary'
                display='block'
                sx={{ lineHeight: 1.7 }}>
                {line}
              </Typography>
            ))}
          </Box>
        </Stack>
      </Box>
    </Box>
  </ExceptionMetricsFilterCriteria>
)
